import React, { useState, useEffect } from 'react';

const GRADIENT = 'linear-gradient(135deg, #090A0B 0%, #001a4d 40%, #004AAD 75%, #0082FB 100%)';

const DISCLAIMER_TEXT = {
  free: 'This report is generated using AI analysis and is intended as a guide. Scores are relative to industry benchmarks. © ' + new Date().getFullYear() + ' DecX AI. All rights reserved.',
  paid: 'This report contains AI-generated analysis supplemented with human expert review. Competitor data is based on publicly available information. Recommendations are suggestions and outcomes may vary. © ' + new Date().getFullYear() + ' DecX AI. All rights reserved.',
};

const AuditDisclaimer = ({ isFree = false }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 640);
  const [isTablet, setIsTablet] = useState(window.innerWidth >= 640 && window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 640);
      setIsTablet(window.innerWidth >= 640 && window.innerWidth < 1024);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const text = isFree ? DISCLAIMER_TEXT.free : DISCLAIMER_TEXT.paid;

  return (
    <div style={{
      width: '100%',
      maxWidth: '100vw',
      background: '#ffffff',
      height: isMobile ? 'auto' : (isTablet ? 80 : 96),
      minHeight: isMobile ? 60 : 'auto',
      padding: isMobile ? '16px 12px' : (isTablet ? '0 24px' : '0 40px'),
      display: 'flex',
      flexDirection: isMobile ? 'column' : 'row',
      alignItems: isMobile ? 'flex-start' : 'center',
      gap: isMobile ? 12 : (isTablet ? 20 : 36),
      boxSizing: 'border-box',
      borderTop: '1px solid rgba(0,0,0,0.06)',
      overflow: 'hidden',
    }}>
      {/* Left — domain only */}
      <div style={{ 
        flexShrink: 0,
        alignSelf: isMobile ? 'flex-start' : 'center',
      }}>
        <span style={{
          fontSize: isMobile ? 11 : (isTablet ? 12 : 13),
          fontWeight: 700,
          background: GRADIENT,
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          letterSpacing: isMobile ? '0.02em' : '0.04em',
          fontFamily: 'inherit',
        }}>
          decxai.com
        </span>
      </div>

      {/* Divider */}
      {!isMobile && (
        <div style={{
          width: 1,
          height: isTablet ? 32 : 40,
          alignSelf: 'center',
          background: 'rgba(0,0,0,0.1)',
          flexShrink: 0,
          borderRadius: 1,
        }} />
      )}

      {/* Disclaimer text — pure black */}
      <p style={{
        fontSize: isMobile ? 10 : (isTablet ? 11 : 13),
        color: '#000000',
        lineHeight: isMobile ? 1.5 : 1.7,
        margin: 0,
        flex: 1,
        fontFamily: 'inherit',
        wordBreak: 'break-word',
        minWidth: 0,
      }}>
        {text}
      </p>
    </div>
  );
};

export default AuditDisclaimer;